module.exports = __webpack_public_path__ + "static/assets/91935ca9beb1c941b4acfae2115578cc.png";